/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
function patienceDiff(aLines, bLines, diffPlusFlag) {
  function findUnique(arr, lo, hi) {
    const lineMap = new Map();

    for (let i = lo; i <= hi; i++) {
      const line = arr[i];

      if (lineMap.has(line)) {
        lineMap.get(line).count++;
        lineMap.get(line).index = i;
      } else {
        lineMap.set(line, {
          count: 1,
          index: i,
        });
      }
    }

    lineMap.forEach((val, key, map) => {
      if (val.count !== 1) {
        map.delete(key);
      } else {
        map.set(key, val.index);
      }
    });

    return lineMap;
  }

  function uniqueCommon(aArray, aLo, aHi, bArray, bLo, bHi) {
    const ma = findUnique(aArray, aLo, aHi);
    const mb = findUnique(bArray, bLo, bHi);

    ma.forEach((val, key, map) => {
      if (mb.has(key)) {
        map.set(key, {
          indexA: val,
          indexB: mb.get(key),
        });
      } else {
        map.delete(key);
      }
    });

    return ma;
  }

  function longestCommonSubsequence(abMap) {
    const ja = [];

    // First, walk the list creating the jagged array.

    abMap.forEach((val) => {
      let i = 0;

      while (ja[i] && ja[i][ja[i].length - 1].indexB < val.indexB) {
        i++;
      }

      if (!ja[i]) {
        ja[i] = [];
      }

      if (i > 0) {
        // eslint-disable-next-line no-param-reassign
        val.prev = ja[i - 1][ja[i - 1].length - 1];
      }

      ja[i].push(val);
    });

    // Now, pull out the longest common subsequence.

    let lcs = [];

    if (ja.length > 0) {
      const n = ja.length - 1;
      lcs = [ja[n][ja[n].length - 1]];

      while (lcs[lcs.length - 1].prev) {
        lcs.push(lcs[lcs.length - 1].prev);
      }
    }

    return lcs.reverse();
  }

  const result = [];

  const aMove = [];
  const aMoveIndex = [];
  const bMove = [];
  const bMoveIndex = [];

  function addToResult(aIndex, bIndex) {
    if (bIndex < 0) {
      aMove.push(aLines[aIndex]);
      aMoveIndex.push(result.length);
    } else if (aIndex < 0) {
      bMove.push(bLines[bIndex]);
      bMoveIndex.push(result.length);
    }

    result.push({
      line: aIndex >= 0 ? aLines[aIndex] : bLines[bIndex],
      aIndex,
      bIndex,
    });
  }
  function addSubMatch(aLo, aHi, bLo, bHi) {
    // Match any lines at the beginning of aLines and bLines.

    while (aLo <= aHi && bLo <= bHi && aLines[aLo] === bLines[bLo]) {
      addToResult(aLo++, bLo++);
    }

    const aHiTemp = aHi;

    while (aLo <= aHi && bLo <= bHi && aLines[aHi] === bLines[bHi]) {
      aHi--;
      bHi--;
    }

    const uniqueCommonMap = uniqueCommon(aLines, aLo, aHi, bLines, bLo, bHi);

    if (uniqueCommonMap.size === 0) {
      while (aLo <= aHi) {
        addToResult(aLo++, -1);
      }

      while (bLo <= bHi) {
        addToResult(-1, bLo++);
      }
    } else {
      // eslint-disable-next-line no-use-before-define
      recurseLCS(aLo, aHi, bLo, bHi, uniqueCommonMap);
    }

    // Finally, let's add the matches at the end to the result.

    while (aHi < aHiTemp) {
      addToResult(++aHi, ++bHi);
    }
  }
  function recurseLCS(aLo, aHi, bLo, bHi, uniqueCommonMap) {
    const x = longestCommonSubsequence(
      uniqueCommonMap || uniqueCommon(aLines, aLo, aHi, bLines, bLo, bHi)
    );

    if (x.length === 0) {
      addSubMatch(aLo, aHi, bLo, bHi);
    } else {
      if (aLo < x[0].indexA || bLo < x[0].indexB) {
        addSubMatch(aLo, x[0].indexA - 1, bLo, x[0].indexB - 1);
      }

      let i;
      for (i = 0; i < x.length - 1; i++) {
        addSubMatch(x[i].indexA, x[i + 1].indexA - 1, x[i].indexB, x[i + 1].indexB - 1);
      }

      if (x[i].indexA <= aHi || x[i].indexB <= bHi) {
        addSubMatch(x[i].indexA, aHi, x[i].indexB, bHi);
      }
    }
  }

  recurseLCS(0, aLines.length - 1, 0, bLines.length - 1);

  if (diffPlusFlag) {
    return {
      lines: result,
      aMove,
      aMoveIndex,
      bMove,
      bMoveIndex,
    };
  }

  return {
    lines: result,
  };
}

const SPLIT = {
  s: -1,
  e: -1,
  t: 1,
};

const splitSubArray = (flag, temp, arr, type, i) => {
  const res = [...arr];
  if (flag === type) {
    temp.e = i;
  }
  if (flag !== type) {
    if (temp.t < 1) {
      res.push(temp);
      temp = { ...SPLIT };
    }
    flag = type;
    if (temp.t !== type) {
      if (temp.s === -1) temp.s = i;
      if (temp.s > -1) temp.e = i;
      temp.t = type;
    }
  }
  return [flag, temp, res];
};

// return array groups of splited string
// [
//     {s, e, t} // s:start, e:end, t:type
//      ...
// ]
const splitArray = (lines) => {
  let flag = 1; // -2: add, -1: remove, 0: unchange
  let res = [];
  let temp = { ...SPLIT };

  lines.forEach((e, i) => {
    if (e === -1) {
      const [_flag, _temp, _res] = splitSubArray(flag, temp, res, -1, i);
      flag = _flag;
      temp = _temp;
      res = _res;
    } else if (e === -2) {
      const [_flag, _temp, _res] = splitSubArray(flag, temp, res, -2, i);
      flag = _flag;
      temp = _temp;
      res = _res;
    } else {
      const [_flag, _temp, _res] = splitSubArray(flag, temp, res, 0, i);
      flag = _flag;
      temp = _temp;
      res = _res;
    }
  });
  res.push(temp);

  return res;
};

// Return array of splited string
// [
//     {str, type}, // str: splited string, type: unchange|add|remove
//     ...
// ]
export const modifyDiffString = (a, b) => {
  const { lines } = patienceDiff(a, b);

  const srcLines = lines.map((e) => {
    if (e.aIndex !== -1) return e.bIndex;
    return -2;
  });

  const srcString = lines.map((e) => e.line).join('');

  const splitStrArray = splitArray(srcLines);

  const arr = [];
  splitStrArray.forEach((e) => {
    const str = srcString.slice(e.s, e.e + 1);
    arr.push({ str, type: e.t });
  });

  return arr;
};

// Render p tag of each splited string
export const renderDiffString = (a, b) => {
  if (!a || !b) return null;
  const splitArr = modifyDiffString(a, b);
  // -2: add, -1: remove, 0: unchange
  const html = splitArr.map((e, i) => (
    <p
      // eslint-disable-next-line react/no-array-index-key
      key={`${e.str.slice(0, 4)}_${i}`}
      // eslint-disable-next-line no-nested-ternary
      className={`inline ${e.type === -1 ? 'bg-red-100' : e.type === -2 ? 'bg-green-100' : ''}`}
    >
      {e.str}
    </p>
  ));
  return html;
};

export const generateDiffStrings = (a, b) => {
  const result = {
    left: null,
    right: null,
  };
  const splitArr = modifyDiffString(a ?? '', b ?? '');
  // (type) -2: add, -1: remove, 0: unchange
  const leftStringArr = splitArr?.filter((item) => item?.type !== -2);
  const rightStringArr = splitArr?.filter((item) => item?.type !== -1);

  if (
    leftStringArr?.every((item) => item?.type === 0) &&
    rightStringArr?.every((item) => item?.type === 0)
  ) {
    result.left = (
      <span className="inline">{leftStringArr?.map((item) => item?.str ?? '').join('')}</span>
    );
    result.right = (
      <span className="inline">{rightStringArr?.map((item) => item?.str ?? '').join('')}</span>
    );
  } else {
    result.left = leftStringArr?.map((item, index) => (
      <span
        // eslint-disable-next-line react/no-array-index-key
        key={`${item.str.slice(0, 4)}_${index}`}
        className={`inline ${item?.type === -1 ? 'bg-red-200' : 'bg-red-100'}`}
      >
        {item.str}
      </span>
    ));

    result.right = rightStringArr?.map((item, index) => (
      <span
        // eslint-disable-next-line react/no-array-index-key
        key={`${item.str.slice(0, 4)}_${index}`}
        className={`inline ${item?.type === -2 ? 'bg-green-200' : 'bg-green-100'}`}
      >
        {item.str}
      </span>
    ));
  }

  return result;
};
